import { mapTwoWayState } from 'schepotin-vuex-helpers';

export default {
    computed: {
        /**
         * Generates two way {@link https://vuejs.org/v2/guide/computed.html#Computed-Setter | computed properties}
         *
         * Documentation {@link https://www.npmjs.com/package/schepotin-vuex-helpers#maptwowaystate | mapTwoWayState}
         */
        ...mapTwoWayState({
            namespace: 'auth',
            prefix: true,
        }, [
            'id',
            'logged',
            'name',
            'username',
            'email',
            'roleId',
            'image',
            'password',
            'passwordConfirmation',
            'currentLang',
            'currentDirection',
            'workspaceLanguageLoaded',
            'token',
            'dashboard',
            'badges',
            'certificates',
        ]),
        languages() {
            return [{
                language: 'en',
                direction: 'ltr',
            }, {
                language: 'he',
                direction: 'rtl',
            }, {
                language: 'zh',
                direction: 'ltr',
            }];
        },
        baseUrl() {
            let url = 'http://api.app.robokids.online';

            if (window.location.hostname !== '') {
                url = `${window.location.protocol}//api.${window.location.hostname}`;
            }

            return url;
        },
        webAppUrl() {
            let url = 'http://app.robokids.online';

            if (window.location.hostname !== '') {
                url = `${window.location.protocol}//${window.location.hostname}`;
            }

            return url;
        },
        language() {
            return this.authCurrentLang !== 'en' ? this.$t(`translation.${this.authCurrentLang}`) : this.$t('translation.en');
        },
    },
    methods: {
        async lang(language, direction) {
            try {
                await this.$store.dispatch('auth/changeLanguage', {
                    language: language,
                    direction: direction,
                });
            } catch (e) {
                // Code
            }

            /**
             * Set language.
             */
            this.$i18n.locale = language;
            this.authCurrentLang = language;
            this.$validator.locale = language;
            document.querySelector('html').setAttribute('lang', language);

            /**
             * Set direction.
             */
            this.authCurrentDirection = direction;
            document.querySelector('html').setAttribute('dir', direction);

            window.location.reload();
        },
        async logout() {
            await this.$store.dispatch('auth/logout');

            this.$router.push({
                name: 'auth.login',
            });
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/auth.js